module.exports = __webpack_public_path__ + "static/media/9.fef80097.jpg";